<template>
  <v-container fluid>
    <v-alert
      v-model="successDialog"
      dismissible
      prominent
      type="success"
      transition="scale-transition"
    >
      New terms and conditions version successfully uploaded.
    </v-alert>
    <v-file-input
      v-model="newVersion"
      :rules="rules"
      accept="application/pdf"
      placeholder="New Terms and Conditions PDF"
    />
    <v-text-field
      v-model="versionName"
      label="Version Name"
      :rules="rules"
    />
    <v-textarea
      v-model="changeNotes"
      label="What's New"
      :rules="rules"
      outlined
      rows="2"
      counter
    />
    <v-btn
      color="primary"
      :loading="isUploading"
      @click="createNewTermsAndConditionsVersion"
    >
      Upload
    </v-btn>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NewTermsAndConditionsUploadComponent',
  data: () => ({
    rules: [(v) => v !== null],
    newVersion: null,
    versionName: null,
    isUploading: false,
    successDialog: false,
    changeNotes: null,
  }),
  methods: {
    ...mapActions('apiClient', ['create']),
    async createNewTermsAndConditionsVersion() {
      this.isUploading = true;
      const req = {
        versionName: this.versionName,
        changeNotes: this.changeNotes,
      };

      const formData = new FormData();
      formData.append('uploadFile', this.newVersion, this.newVersion.name);

      let createdVersion = {};

      await this.create({ url: '/config/terms', body: req }).then(
        (response) => {
          createdVersion = response.data;
        },
      );

      await this.create({ url: `/assets/${createdVersion.id}`, body: formData }).then(
        () => {
          this.isUploading = false;
        },
      );

      this.successDialog = true;
      setTimeout(() => {
        this.succesDialog = false;
      }, 5000);
    },
  },
};
</script>
